"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgInboxFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8 10.988a1 1 0 011 1 3 3 0 006 0 1 1 0 011-1h3.688L17.938 4H6.062l-1.749 6.988H8zm14 1v8.001a2 2 0 01-1.999 2l-16 .01a2 2 0 01-2.001-2v-8.011l2.12-8.474A2 2 0 016.062 2H17.94a2 2 0 011.94 1.514L22 11.988z' }))); };
exports.default = SvgInboxFilled;
//# sourceMappingURL=InboxFilled.js.map